import { PROPOSAL_RIDERS } from "../constant/gms-constant";

export const isInvalidRiderAmount = (riderId: number, amount: number) => {
    if (Object.values(PROPOSAL_RIDERS.GHIR.productFor).some((id) => id === riderId)) {
        return amount < 100 || amount > 300;
    }

    if (Object.values(PROPOSAL_RIDERS.GAMERR.productFor).some((id) => id === riderId)) {
        return amount < 500;
    }

    if (Object.values(PROPOSAL_RIDERS.GMBDR.productFor).some((id) => id === riderId)) {
        return ![10000, 20000, 30000].includes(amount);
    }

    return amount < 1;
};